import { motion } from "framer-motion";
import { HeartHandshake, Gauge, Users } from "lucide-react";
import { IMAGES } from "../../data/site";
import { Reveal, SectionHeading } from "./Reveal";

const VALUES = [
  { icon: HeartHandshake, title: "Bienveillance", text: "On apprend mieux sans stress. Nos moniteurs mettent la pédagogie et la confiance au cœur de chaque leçon." },
  { icon: Gauge, title: "Exigence", text: "Véhicules récents, parcours d'examen réels, suivi individualisé : rien n'est laissé au hasard." },
  { icon: Users, title: "Proximité", text: "Une équipe qui vous connaît par votre prénom, en plein centre de Chatou." },
];

export const About = () => (
  <section id="apropos" data-testid="about-section" className="relative py-24 sm:py-32 bg-[#F8F9FA] overflow-hidden">
    <div className="glow-blob absolute top-10 -left-40 w-[460px] h-[460px] rounded-full bg-violet-200/45" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <SectionHeading
          label="À propos"
          title="L'auto-école de Chatou qui vous veut du bien"
          description="Bestconduite78 accompagne les habitants de Chatou, du Vésinet, de Croissy-sur-Seine et de toutes les Yvelines vers leur permis de conduire. Notre conviction : une formation de qualité, humaine et transparente, est la meilleure garantie de réussite."
        />
        <div className="grid sm:grid-cols-3 gap-5 mt-10">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={0.1 + i * 0.08}>
              <motion.div
                whileHover={{ y: -5 }}
                transition={{ duration: 0.25 }}
                data-testid={`about-value-${i}`}
                className="rounded-2xl bg-white border border-slate-100 p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] h-full text-center sm:text-left"
              >
                <div className="w-10 h-10 rounded-xl bg-violet-100 flex items-center justify-center mx-auto sm:mx-0">
                  <v.icon size={18} className="text-violet-700" />
                </div>
                <h3 className="font-heading font-bold text-slate-900 text-base mt-3.5">{v.title}</h3>
                <p className="text-[13px] text-slate-500 leading-relaxed mt-1.5">{v.text}</p>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15}>
        <motion.div whileHover={{ scale: 0.985 }} transition={{ duration: 0.3 }} className="relative">
          <div className="glow-blob absolute -inset-5 rounded-[2.5rem] bg-violet-300/35" />
          <img
            src={IMAGES.about}
            alt="Élève conducteur au volant d'un véhicule récent de l'auto-école Bestconduite78 à Chatou"
            loading="lazy"
            data-testid="about-image"
            className="relative rounded-[2rem] w-full aspect-[4/3.4] object-cover shadow-[0_24px_70px_rgb(0,0,0,0.12)]"
          />
          <div className="absolute -bottom-6 right-6 bg-white/90 backdrop-blur-xl rounded-2xl border border-slate-100 shadow-[0_16px_50px_rgb(0,0,0,0.10)] px-6 py-4" data-testid="about-exp-card">
            <p className="font-heading font-black text-2xl text-violet-700 leading-none">5/5</p>
            <p className="text-xs text-slate-500 font-semibold mt-1.5">sur nos avis Google</p>
          </div>
        </motion.div>
      </Reveal>
    </div>
  </section>
);
